import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ColorSwatch } from 'site-modules/shared/components/color-swatch/color-swatch';

export function ColorInfo({ color = null, colorName = null, label, className = '', style = {}, colorSide = '' }) {
  return (
    <div className={classnames('size-14', className)} style={style}>
      <ColorSwatch
        color={color}
        displayColorName={false}
        title={`${colorSide} color: ${colorName}`}
        classNames="rounded"
        style={{
          width: '0.75rem',
          height: '0.75rem',
          borderWidth: '1px',
          display: 'inline-block',
          marginRight: '0.25rem',
        }}
      />
      <span style={{ verticalAlign: 'text-bottom' }}>{label}</span>
    </div>
  );
}

ColorInfo.propTypes = {
  color: PropTypes.shape({}),
  colorName: PropTypes.string,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  colorSide: PropTypes.string,
};
